import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import {
  categoryChange,
  categoryNameAction,
} from "../../redux/slices/selectCategories";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../popoverBtn";
import Form from "react-bootstrap/Form";

function SelectCategory({ className, popoverText }) {
  const { lang, categoriesState, optional } = useSelector((state) => ({
    lang: state.changeLang.language.categories,
    categoriesState: state.categories,
    optional: state.changeLang.language.stepTwo.optional[0],
  }));
  const { categories, categoryChange: categoryId } = categoriesState;
  const dispatch = useDispatch();
  const [selectItem, setSelectItem] = useState("");

  const handleSelect = (e) => {
    if (!e.target.value) {
      setSelectItem("");
      dispatch(categoryChange(""));
      dispatch(categoryNameAction(""));
      return;
    }
    const item = Number(e.target.value);
    setSelectItem(item);
    dispatch(categoryChange([item]));
    dispatch(
      categoryNameAction(
        categories.find((category) => category.id === item).name
      )
    );
  };

  useEffect(() => {
    if (Array.isArray(categoryId)) {
      setSelectItem(categoryId[0]);
    }
  }, [categoryId]);

  return (
    <>
      <div
        className={classNames("col-12 mx-auto mb-3", {
          "col-lg-6": !className,
          [className]: !!className,
        })}
      >
        <Row className="align-items-center flex-nowrap position-relative">
          <Col xs={12} md={11} className="select_category">
            <Form.Select
              value={selectItem}
              onChange={handleSelect}
              defaultlabel={`${lang[0]} (${optional})`}
              className={classNames("pe-5 pe-md-2 position-relative py-3", {
                "pb-2 pt-4": !!selectItem,
                "text-gray": !selectItem,
              })}
            >
              <>
                <option
                  disabled={true}
                  value={""}
                >{`${lang[0]} (${optional})`}</option>

                {[{ name: lang[2], id: "" }, ...categories].map((i) => (
                  <option key={i.id} value={i.id}>
                    {i.name}
                  </option>
                ))}
              </>
            </Form.Select>
            {selectItem && (
              <small
                className="top-0 left-0 position-absolute m-2 ps-1 text-gray fs-7"
                style={{ opacity: 0.65 }}
              >
                {`${lang[0]} (${optional})`}
              </small>
            )}
          </Col>
          {popoverText !== null && (
            <div className="position-absolute top-50 translate-middle-y end-0 w-auto me-3">
              <PopoverBtn text={lang[1]} />
            </div>
          )}
        </Row>
      </div>
    </>
  );
}

export default memo(SelectCategory);
